module.exports = __webpack_public_path__ + "img/cd81986.gif";